import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { TipTap } from "./TipTap";

export function ConfirmationDialog({
  title,
  content,
  signature,
  dialogOpen,
  handleDialogClose,
  handleDialogConfirm,
  buttonText,
}) {
  const contentRef = React.useRef();
  const conirmDelete = !!content;
  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { minWidth: "500px" } }}
      open={dialogOpen}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {!!title ? (
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      ) : null}
      <DialogContent>
        {conirmDelete ? (
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        ) : null}
        {!content && !!signature ? (
          <>
            <Box
              id="preview"
              sx={{ height: "100%", maxWidth: "100%", p: ".5em" }}
              dangerouslySetInnerHTML={{ __html: signature }}
            />
            {/* <TipTap
              content={signature}
              setEmailContent={(content) => {
                contentRef.current = content;
                
              }}
              ref={() => {}}
              fieldNameApis={[]}
              signatureComp={true}
            /> */}
          </>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleDialogClose}
          sx={{ textTransform: "capitalize" }}
          variant="outlined"
          color="error"
        >
          Cancel
        </Button>
        {conirmDelete ? (
          <Button
            onClick={() => {
              handleDialogConfirm({ data: contentRef.current });
            }}
            autoFocus
            sx={{ textTransform: "capitalize" }}
            variant="contained"
          >
            {buttonText}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
